import ReactDOM from "react-dom";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import CloseIcon from "assets/icons/close.svg?react";
import TagBadge from "components/TagBadge";
import { useTranslation } from "react-i18next";

const ClientRolesModal: FC<Props> = ({ client, refWrapper }) => {
  const { t } = useTranslation();

  if (!refWrapper?.current) return <></>;

  const position = refWrapper.current.getBoundingClientRect();

  return ReactDOM.createPortal(
    <div
      style={{
        left: `${position.left}px`,
        top: `${position.top + 32}px`,
      }}
      className={styles.wrapper}
    >
      <div className={styles.title}>
        {t("clients.rolesList")}
        <CloseIcon className={styles.icon} />
      </div>
      <div className={styles.tags}>
        {client.Tags.map((tag) => (
          <TagBadge tag={tag} />
        ))}
      </div>
    </div>,
    document.body
  );
};

export default ClientRolesModal;
